var map = {
	"./Copy.vue": 86089,
	"./DownloadList.vue": 34787,
	"./Famous.vue": 37837,
	"./FamousInfo.vue": 48560,
	"./Floorplan.vue": 1414,
	"./History.vue": 90365,
	"./Index.vue": 56775,
	"./News.vue": 553,
	"./NewsInfo.vue": 72528,
	"./NotFound.vue": 10324,
	"./SinglePage.vue": 78736,
	"./UserChangePassword.vue": 93596,
	"./UserEdit.vue": 80493,
	"./UserExhibition.vue": 52942,
	"./UserForgotPassword.vue": 17343,
	"./UserLogin.vue": 90959,
	"./UserLogout.vue": 20934,
	"./UserRegister.vue": 13452,
	"./UserReserve.vue": 56674,
	"./UserReserveInfo.vue": 53752,
	"./VueCropper - 副本.vue": 28704,
	"./VueCropper.vue": 75217,
	"./upload-cropper.vue": 32369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53730;